<template>
  <div class="card card-custom gutter-b">
    <div class="card-header border-0 py-5">
      <div>
        <h3 class="card-title font-weight-bolder text-dark mb-1">Centro de custos</h3>
        <div class="text-muted">Cadastre os centros de custos da empresa</div>
      </div>
      <div class="card-toolbar">
        <router-link
          :to="{ name: 'relatorioCentrosCustos' }"
          class="btn btn-light-primary font-weight-bolder mr-2"
        >
          Relatório por período
        </router-link>
        <button class="btn btn-dark font-weight-bolder" @click="abrirCadastro()">
          Novo centro de custo
        </button>
      </div>
    </div>

    <div class="card-body pt-0">
      <b-row class="mb-4">
        <b-col md="6">
          <b-form-input v-model="busca" placeholder="Pesquisar pelo nome" />
        </b-col>
        <b-col md="3" class="d-flex align-items-center">
          <b-form-checkbox v-model="incluirInativos" @change="carregar">
            Mostrar inativos
          </b-form-checkbox>
        </b-col>
      </b-row>

      <div v-if="carregando" class="text-center py-8"><b-spinner /></div>
      <div v-else class="table-responsive">
        <table class="table table-head-custom table-vertical-center">
          <thead>
            <tr><th>Nome</th><th>Status</th><th class="text-right">Ações</th></tr>
          </thead>
          <tbody>
            <tr v-for="centro in centrosFiltrados" :key="centro.id">
              <td class="font-weight-bold">{{ centro.nome }}</td>
              <td>
                <span :class="centro.ativo ? 'badge badge-success' : 'badge badge-secondary'">
                  {{ centro.ativo ? "Ativo" : "Inativo" }}
                </span>
              </td>
              <td class="text-right">
                <button class="btn btn-sm btn-info btn-icon mr-2" v-b-tooltip="'Editar'" @click="abrirCadastro(centro)">
                  <Pencil :size="16" />
                </button>
                <button class="btn btn-sm btn-danger btn-icon" v-b-tooltip="'Excluir'" @click="excluir(centro)">
                  <TrashCan :size="16" />
                </button>
              </td>
            </tr>
            <tr v-if="centrosFiltrados.length === 0">
              <td colspan="3" class="text-center text-muted py-6">Nenhum centro de custo encontrado.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal v-model="modalAberto" :title="form.id ? 'Editar centro de custo' : 'Novo centro de custo'" hide-footer>
      <b-form @submit.prevent="salvar">
        <b-form-group label="Nome" label-for="centro-custo-nome">
          <b-form-input id="centro-custo-nome" v-model.trim="form.nome" maxlength="100" autofocus required />
        </b-form-group>
        <b-form-checkbox v-if="form.id" v-model="form.ativo" class="mb-5">Centro de custo ativo</b-form-checkbox>
        <div class="text-right">
          <button type="button" class="btn btn-light mr-2" @click="modalAberto = false">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="salvando || !form.nome">
            <b-spinner v-if="salvando" small class="mr-1" /> Salvar
          </button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCan from "vue-material-design-icons/TrashCan.vue";

export default {
  name: "CentroCustoIndex",
  components: { Pencil, TrashCan },
  data() {
    return {
      centros: [],
      busca: "",
      incluirInativos: true,
      carregando: false,
      salvando: false,
      modalAberto: false,
      form: { id: null, nome: "", ativo: true },
    };
  },
  computed: {
    centrosFiltrados() {
      const busca = this.busca.trim().toLocaleLowerCase("pt-BR");
      return busca
        ? this.centros.filter((centro) => (centro.nome || "").toLocaleLowerCase("pt-BR").includes(busca))
        : this.centros;
    },
  },
  created() {
    this.carregar();
  },
  methods: {
    async carregar() {
      this.carregando = true;
      try {
        const { data } = await this.$http.post("/financeiro/centros-custos/lista", {
          incluir_inativos: this.incluirInativos,
        });
        this.centros = Array.isArray(data) ? data : data.data || [];
      } finally {
        this.carregando = false;
      }
    },
    abrirCadastro(centro = null) {
      this.form = centro
        ? { id: centro.id, nome: centro.nome, ativo: !!centro.ativo }
        : { id: null, nome: "", ativo: true };
      this.modalAberto = true;
    },
    async salvar() {
      if (!this.form.nome) return;
      this.salvando = true;
      try {
        const endpoint = this.form.id
          ? "/financeiro/centros-custos/update"
          : "/financeiro/centros-custos/create";
        await this.$http.post(endpoint, this.form);
        this.modalAberto = false;
        await this.carregar();
        this.$toast.success("Centro de custo salvo com sucesso!");
      } finally {
        this.salvando = false;
      }
    },
    async excluir(centro) {
      const resultado = await this.$swal.fire({
        icon: "warning",
        title: `Excluir o centro de custo ${centro.nome}?`,
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        confirmButtonColor: "#f64e60",
      });
      if (!resultado.isConfirmed) return;
      await this.$http.post("/financeiro/centros-custos/delete", { id: centro.id });
      await this.carregar();
      this.$toast.success("Centro de custo excluído!");
    },
  },
};
</script>
